import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";
export var isAdmin = function() {
    var _UserStore_get_user_roles, _UserStore_get_user;
    return !!((_UserStore_get_user = UserStore.get().user) === null || _UserStore_get_user === void 0 ? void 0 : (_UserStore_get_user_roles = _UserStore_get_user.roles) === null || _UserStore_get_user_roles === void 0 ? void 0 : _UserStore_get_user_roles.find(function(role) {
        return role === UserRole.ADMIN;
    }));
};
